import React, { useState } from "react";
import "./currency.css";

// components imports
import CurrenciesTable from "../../../../../Components/BoltTable/BoltTable";
import AddCurrency from "./Components/AddCurrency/AddCurrency";
import Confirm from "../../../../../Components/Popups/Confirm";
import Tooltip from "../../../../../Components/Tooltip/Tooltip";
import BoltButton from "../../../../../Components/UI/Buttons/BoltButton";
// apis imports
import {
  deleteCurrency,
  getCurrenciesList,
} from "../../../../../services/admin.services";
// library imports
import { FcPlus } from "react-icons/fc";
import { MdOutlineCancel } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";
import EditCurrency from "./Components/EditCurrency/EditCurrency";
import { useTranslation } from "react-i18next";

const CurrencyStock = ({ setSnack }) => {
  const { t } = useTranslation("admin");
  const [open, setOpen] = useState(false);
  const [editCurrencyOpen, setEditCurrencyOpen] = useState(false);
  const [loader, setloader] = useState(false);

  const [transferCurrencies, setTransferCurrencies] = useState([]);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [refresh, setRefresh] = useState();

  const columns = [
    {
      id: 1,
      label: t("newsletter.code"),
      render: (row) => <>{row?.code ?? "-"}</>,
      width: "200px",
    },
    {
      id: 2,
      label: t("newsletter.name"),
      render: (row) => <>{row?.name ?? "-"}</>,
      width: "200px",
    },
    {
      id: 3,
      label: t("newsletter.rate"),
      render: (row) => <>{row?.rate ?? "-"}</>,
      width: "200px",
    },
    {
      id: 3,
      label: t("newsletter.symbol"),
      render: (row) => <>{row?.symbol ?? "-"}</>,
      width: "200px",
    },
    {
      id: 4,
      label: t("newsletter.actions"),
      render: (row) => (
        <>
          <div className="table_action__wrap">
            <Tooltip title={t("newsletter.editDetails")}>
              <div
                className="table_action__btn"
                onClick={() => {
                  setEditCurrencyOpen(row);
                }}
              >
                <FaRegEdit size={10} />
                {t("common:actions.edit")}
              </div>
            </Tooltip>

            <Tooltip title={t("newsletter.deleteItem")}>
              <div
                className="table_action__btn"
                onClick={() => setConfirmDelete(row)}
              >
                <MdOutlineCancel size={10} />
                {t("common:actions.delete")}
              </div>
            </Tooltip>
          </div>
        </>
      ),
      width: "200px",
    },
  ];

  const fetchCurrenciesList = async (page, perPage, filter) => {
    const response = await getCurrenciesList(page, perPage, filter);
    if (!response.error) {
      setTransferCurrencies(response?.data?.result);
    } else {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
    }
  };

  const handleDeleteRequest = async (data) => {
    if (data.id) {
      setloader(true);
      const response = await deleteCurrency(data.id);
      setConfirmDelete(false);
      if (!response.error && response?.data?.success) {
        setTransferCurrencies((prevTransferCurrencies) => {
          return {
            ...prevTransferCurrencies,
            data: prevTransferCurrencies?.data?.filter(
              (d) => d?.id != data?.id,
            ),
          };
        });
        setloader(false);
        setConfirmDelete(false);
        setSnack((snack) => {
          return {
            ...snack,
            open: true,
            text: t("newsletter.requestDeletedSuccessfully"),
            severity: "success",
          };
        });
      } else {
        setloader(false);
        setSnack((snack) => {
          return {
            ...snack,
            open: true,
            text: t("newsletter.couldntCancelThisRequest"),
            severity: "error",
          };
        });
      }
    }
  };

  return (
    <>
      <Confirm
        open={confirmDelete}
        setOpen={setConfirmDelete}
        handleConfirm={() => handleDeleteRequest(confirmDelete)}
        text={t("newsletter.confirmDeleteRequest")}
        loader={loader}
      />
      <AddCurrency
        open={open}
        setOpen={setOpen}
        setSnack={setSnack}
        setRefresh={setRefresh}
      />
      <EditCurrency
        open={editCurrencyOpen}
        setOpen={setEditCurrencyOpen}
        setSnack={setSnack}
        setTransferCurrencies={setTransferCurrencies}
      />
      <div className="custom__table_size1 actionbtn__needtobe_fixwidth">
        <CurrenciesTable
          tableTitle={t("newsletter.currencies")}
          tableId="currencyTableForAdmin"
          message={t("newsletter.noCurrenciesAvailableToDisplay")}
          searchPlaceHolder={t("newsletter.searchCurrencies")}
          columns={columns}
          data={transferCurrencies}
          getAllData={fetchCurrenciesList}
          refresh={refresh}
          headerButtons={
            <div className="flex gap-1.5 flex-wrap">
              <BoltButton
                icon={FcPlus}
                label={t("newsletter.addCurrency")}
                onClick={() => setOpen(true)}
                variant="success"
                size="sm"
              />
            </div>
          }
        />
      </div>
    </>
  );
};

export default CurrencyStock;
